<!--
 * @Author: zhengxiaoxiao
 * @Date: 2020-08-12 15:55:43
 * @Description: 
-->
/*
* @Author: yongwenhao
* @Date: 2020-04-09 16:23:01
* @describe: 新闻banner
*/
<template>
    <div class="new-banner" :style="{background: `url(${bannerContent.src})`,backgroundSize: 'cover',backgroundPosition: 'center'}">
        <div class="title-warp">
            <ElRow class="title-content">
                <ElCol>
                    <h1 class="title">{{bannerContent.title}}</h1>
                </ElCol>
            </ElRow>
        </div>
    </div>
</template>

<script>
    export default {
        name: "banner",
        props: {
            bannerContent: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        }
    }
</script>

<style lang='less' scoped>
    @import "../../../style/constant";

    .new-banner {
        height: 480px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        .title-warp {
            width: @page-width;

            h1 {
                color: #ffffff;
                margin-bottom: 15px;
            }
        }
    }

    @media screen and (max-width: 996px) {
        .title-warp {
            height: 100%;
            padding: 0 20px;

            .title-content {
                display: flex;
                align-items: center;
                height: 100%;
                h1{
                    color: #ffffff !important;
                }
            }
        }

        .new-banner {
            height: 40vh;
        }
    }
</style>